import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TeamCard from "./TeamCards";
import Particle from "../Particle";
import gloria from "../../Assets/Projects/gloria.jpg";
import galindo from "../../Assets/Projects/galindo.jpg";
import golriz from "../../Assets/Projects/golriz.jpg";
import aaron from "../../Assets/Projects/aaron.jpg";
import trinity from "../../Assets/Projects/trinity.jpg";
import andy from "../../Assets/Projects/andy.jpg";
import { Trans, useTranslation } from "react-i18next";

function Team() {
  const { t } = useTranslation();

  const memberCopy = t("teamPage.members", { returnObjects: true });
  const memberCopyByKey = (Array.isArray(memberCopy) ? memberCopy : []).reduce((acc, item) => {
    if (item && item.key) acc[item.key] = item;
    return acc;
  }, {});

  const teamMembers = [
    {
      key: "golriz",
      name: "Golriz Sedaghat",
      email: "golriz@choicestfruit.com",
      linkedin: "https://www.linkedin.com/in/golriz-sedaghat-25a635105/",
      image: golriz,
    },
    {
      key: "aaron",
      name: "Aaron Enyetu",
      email: "aaron@choicestfruit.com",
      linkedin: "https://www.linkedin.com/in/aaron-enyetu/",
      image: aaron,
    },
    {
      key: "triniti",
      name: "Triniti Bunton",
      linkedin: "https://www.linkedin.com/in/triniti-bunton-8983a799/",
      image: trinity,
    },
    {
      key: "andy",
      name: "Andy Hernandez",
      linkedin: "https://www.linkedin.com/in/andyhdz/",
      image: andy,
    },
    {
      key: "galindo",
      name: "Galindo R Aliyo",
      email: "galindo@choicestfruit.com",
      linkedin: "https://www.linkedin.com/in/galindo-aliyo-b716a594/",
      image: galindo,
    },
    {
      key: "gloria",
      name: "Gloria Ludigo",
      email: "gloria@choicestfruit.com",
      linkedin: "https://www.linkedin.com/in/gloria-ludigo-b2ab41140/",
      image: gloria,
    },
  ].map((m) => {
    const copy = memberCopyByKey[m.key] || {};
    return {
      ...m,
      role: copy.role || "",
      description: copy.description || "",
    };
  });


  return (
    <Container fluid className="about-section team-page">
      <Particle />
      <Container className="team-container">
        <header className="team-hero">
          <div className="team-hero-badge">OUR LEADERSHIP</div>
          <h1 className="team-hero-title">
            <Trans i18nKey="teamPage.hero.title" components={{ purple: <strong className="purple" /> }} />
          </h1>
          <p className="team-hero-lead">
            {t("teamPage.hero.lead")}
          </p>
          <div className="team-hero-accent"></div>
        </header>

        <section className="team-section" aria-label={t("teamPage.a11y.members")}>
          <Row className="team-grid" style={{ justifyContent: "center" }}>
            {teamMembers.map((member) => (
              <Col key={member.name} md={4} className="team-col">
                <TeamCard
                  imgPath={member.image}
                  title={member.name}
                  role={member.role}
                  description={member.description}
                  email={member.email}
                  linkedin={member.linkedin}
                  linkedInLabel={t("teamPage.linkedInButton")}
                />
              </Col>
            ))}
          </Row>
        </section>
      </Container>
    </Container>
  );
}

export default Team;
